import { useEffect, useRef } from 'react';

const GUARD_KEY = 'centerBackGuard';

// стек активных обработчиков «Назад»: последний зарегистрированный экран/модалка обрабатывает нажатие первым
const handlers: Array<() => void> = [];
let installed = false;
// предупреждение перед выходом из приложения: показывается, когда стек пуст и «Назад» покидает приложение
let exitWarning: (() => void) | null = null;
let exitConfirmed = false;

const hasGuard = () => !!(window.history.state && (window.history.state as Record<string, unknown>)[GUARD_KEY]);

const pushGuard = () => {
    if (!hasGuard())
        window.history.pushState({ [GUARD_KEY]: true }, '');
};

const install = () => {
    if (!installed) {
        window.addEventListener('popstate', handlePopState);
        installed = true;
    }
};

const uninstall = () => {
    if (installed) {
        window.removeEventListener('popstate', handlePopState);
        installed = false;
    }
};

const handlePopState = () => {
    const handler = handlers[handlers.length - 1];
    if (handler) {
        handler();
        pushGuard();
        return;
    }
    if (exitConfirmed) {
        // пользователь подтвердил выход — не перезаряжаем guard, «Назад» закрывает приложение
        exitConfirmed = false;
        uninstall();
        return;
    }
    if (exitWarning) {
        exitWarning();
        pushGuard();
    }
};

export const useBackButton = (handler: () => void, active = true) => {
    // ref удерживает свежий handler без перерегистрации на каждый рендер
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        if (!active)
            return;
        const wrapped = () => handlerRef.current();
        handlers.push(wrapped);
        install();
        pushGuard();
        return () => {
            const index = handlers.indexOf(wrapped);
            if (index >= 0)
                handlers.splice(index, 1);
            if (handlers.length === 0 && !exitWarning) {
                uninstall();
                if (hasGuard())
                    window.history.back();
            }
        };
    }, [active]);
};

// предупреждение при выходе из приложения системной «Назад»: вызывается, когда все внутренние экраны закрыты
export const setBackExitWarning = (warning: (() => void) | null) => {
    exitWarning = warning;
    if (warning) {
        install();
        pushGuard();
        return;
    }
    exitConfirmed = false;
    if (handlers.length === 0) {
        uninstall();
        if (hasGuard())
            window.history.back();
    }
};

// подтверждение выхода: следующий «Назад» проходит без перезарядки guard и закрывает приложение
export const confirmBackExit = () => {
    exitConfirmed = true;
    window.history.back();
};